<template>
  <div id="app" class="container">
    <div class="row">
      <Form class="no-print col-12 col-md-4" />
      <div class="col-12 col-md-8">
        <div class="row">
          <Contract class="col-12" />
          <ButtonBar docxIsVisible class="no-print col-12" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./components/form/Form";
import Contract from "./components/contract/Contract";
import ButtonBar from "@/shared/components/ButtonBar";

import danishForm from "./translations/form/da_form.js";
import danishContract from "./translations/contract/da_contract.js";

import englishForm from "./translations/form/en_form.js";
import englishContract from "./translations/contract/en_contract.js";

export default {
  components: {
    Form,
    Contract,
    ButtonBar
  },
  computed: {
    formLocale() {
      return this.$store.state.contract.locale.formLocale;
    },
    contractLocale() {
      return this.$store.state.contract.locale.contractLocale;
    }
  },
  watch: {
    formLocale: {
      handler: function() {
        this.mergeTranslations();
      }
    },
    contractLocale: {
      handler: function() {
        this.mergeTranslations();
      }
    }
  },
  methods: {
    mergeTranslations() {
      let form;
      let contract;

      this.formLocale === "da-DK" ? (form = danishForm) : (form = englishForm);
      this.contractLocale === "da-DK"
        ? (contract = danishContract)
        : (contract = englishContract);

      let result = {
        ...contract,
        ...form
      };

      this.$i18n.add(this.contractLocale, result);
      this.$i18n.set(this.contractLocale);
    }
  }
};
</script>

<style>
#app {
  max-width: 1440px;
  background-color: #fff;
  color: #313841;
  font-size: 16px;
  font-family: "GT America", system-ui;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 1rem auto;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/App.vue